var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 60,
    viewBox: "0 0 44 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3201_53071)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43113 0H27.4988L44.4966 17.7336V52.186C44.4966 56.4989 40.9956 60 36.6827 60H7.43113C3.11824 60 -0.382812 56.4989 -0.382812 52.186V7.81395C-0.382812 3.50105 3.11824 0 7.43113 0Z",
    fill: "#8E59FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4736 0V17.5814H44.4969L27.4736 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6807 29.9873H14.4334C13.2918 29.9873 12.353 30.926 12.353 32.0677V41.759C12.353 42.9006 13.2917 43.8394 14.4334 43.8394H29.6807C30.8224 43.8394 31.7357 42.9007 31.7357 41.759V32.0676C31.7357 30.926 30.8224 29.9873 29.6807 29.9873ZM18.5941 32.6004C19.8372 32.6004 20.8266 33.6152 20.8266 34.8329C20.8266 36.076 19.8372 37.0908 18.5941 37.0908C17.3509 37.0908 16.3362 36.076 16.3362 34.8329C16.3362 33.6152 17.3509 32.6004 18.5941 32.6004ZM30.3657 41.759C30.3657 42.1395 30.0613 42.4693 29.6807 42.4693H14.4334C14.0528 42.4693 13.7484 42.1395 13.7484 41.759V41.3531L16.5137 38.5878L18.797 40.8711C19.0761 41.1502 19.5074 41.1502 19.7864 40.8711L25.5201 35.1374L30.3657 39.9831V41.759Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3201_53071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image_placeholder.e28db542ed661040f18bdfebcb92ee69.svg";
export { ForwardRef as ReactComponent };